<template>
  <div class="bg-white shadow-md rounded-xl p-4 w-full flex flex-col justify-between">
    <!-- Header -->
    <div class="flex justify-between items-center">
      <p class="text-gray-900 font-semibold text-lg">Avg. Visit Duration</p>
      <div v-if="loading" class="animate-pulse h-4 w-8 bg-gray-200 rounded"></div>
      <div v-else class="flex items-center space-x-2">
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div class="mt-4">
        <div v-if="loading" class="animate-pulse h-8 w-32 bg-gray-200 rounded mb-2"></div>
        <p v-else class="text-3xl font-bold text-gray-900">
          {{ formattedDuration }}
          <span 
            :class="percentageChangeClass" 
            class="text-sm inline-flex items-center ml-2"
          >
            {{ percentageChangeDirection }} {{ Math.abs(percentageChange) }}%
          </span>
        </p>
        <div v-if="loading" class="animate-pulse h-4 w-40 bg-gray-200 rounded mt-1"></div>
        <p v-else class="text-gray-400 text-sm mt-1">
          {{ changeDirection }} than last {{ comparisonPeriodText }}
        </p>
      </div>

      <!-- Chart Image - dynamically choose based on trend -->
      <div class="mt-4 flex justify-end">
        <img 
          :src="chartImageSrc" 
          :alt="`${changeDirection} chart`" 
          class="w-20 h-auto" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../../router/api"; // Adjust the import path as needed

export default {
  name: 'AvgVisitDuration',
  data() {
    return {
      loading: true,
      duration: 0,
      formattedDuration: '00:00:00',
      percentageChange: 0,
      isDecreasing: false,
      selectedPeriod: 'current_week',
      compareWith: 'previous_week',
      comparisonPeriodText: 'week',
      visitCount: 0
    }
  },
  computed: {
    percentageChangeDirection() {
      return this.percentageChange >= 0 ? '↑' : '↓';
    },
    percentageChangeClass() {
      return this.percentageChange >= 0 ? 'text-green-500' : 'text-red-500';
    },
    changeDirection() {
      return this.percentageChange >= 0 ? 'increased' : 'decreased';
    },
    chartImageSrc() {
      // Assuming you have these images in your assets folder
      return this.percentageChange >= 0 
        ? require('@/assets/chart-placeholder.png') 
        :  require('@/assets/red-chart.svg');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      
      // Set appropriate comparison period based on selected period
      if (this.selectedPeriod === 'current_week') {
        this.compareWith = 'previous_week';
        this.comparisonPeriodText = 'week';
      } else if (this.selectedPeriod === 'current_month') {
        this.compareWith = 'previous_month';
        this.comparisonPeriodText = 'month';
      } else if (this.selectedPeriod === 'current_year') {
        this.compareWith = 'previous_year';
        this.comparisonPeriodText = 'year';
      }
      
      try {
        const response = Api.getAvgDurationData({
            time_period: this.selectedPeriod,
            compare_with: this.compareWith
        });
        
        
        const data = response.data;
        
        // Update component data
        this.duration = data.avg_visit_duration_seconds;
        this.formattedDuration = this.formatDuration(data.avg_visit_duration_seconds);
        this.percentageChange = data.percentage_change;
        this.isDecreasing = data.change_direction === 'decrease';
        this.visitCount = data.visits_count;
      } catch (error) {
        console.error('Error fetching visit duration data:', error);
        // Set fallback values in case of error
        this.formattedDuration = '00:00:00';
        this.percentageChange = 0;
      } finally {
        this.loading = false;
      }
    },
    
    formatDuration(seconds) {
      // Format seconds into HH:MM:SS
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      
      return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0')
      ].join(':');
    }
  },
  mounted() {
    this.fetchData();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/VisitDuration.vue